<template>
  <div class="cv-box">
    <template v-if="hasDefaultSlot">
      <slot></slot>
    </template>
    <template v-else>
      <CardBody>
        <ElementBox class="-center">
          <HeadingIcon class="-primary -bold">
            <IconBox src="checknote" class="-md"></IconBox>
            <h3 class="heading">かんたんお借り入れ診断</h3>
          </HeadingIcon>
          <p class="text">2つのご入力項目でその場ですぐに結果がわかります！</p>
          <btn-main class="-normal" router-name="sv021">チェックする</btn-main>
        </ElementBox>
        <ElementBox class="-center">
          <HeadingIcon class="-primary -bold">
            <IconBox src="pen" class="icon -md"></IconBox>
            <h3 class="heading">新規お申し込み</h3>
          </HeadingIcon>

          <p class="text">お申し込みはパソコン・スマートフォンでWEB完結！</p>
          <template v-if="isWebView()">
            <BtnMain class="-main" href="/entry/agreement"
              >今すぐ申し込む</BtnMain
            >
          </template>
          <template v-else>
            <BtnMain class="-main" router-name="en001">今すぐ申し込む</BtnMain>
          </template>
        </ElementBox>
      </CardBody>
    </template>
  </div>
</template>

<script>
import CardBody from "@/components/card/CardBody";
import ElementBox from "@/components/elements/ElementBox";
import HeadingIcon from "@/components/heading/HeadingIcon";
import IconBox from "@/components/icons/IconBox";
import BtnMain from "@/components/button/BtnMain";
import { isWebView } from "@/utils/UserAgent";

export default {
  name: "CvBox",
  components: {
    BtnMain,
    IconBox,
    HeadingIcon,
    ElementBox,
    CardBody,
  },
  computed: {
    hasDefaultSlot() {
      return !!this.$slots.default;
    },
  },
  methods: {
    isWebView: function () {
      return isWebView();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.cv-box {
  border: 1px solid #cccccc;
  border-radius: 10px;
  background: $success;
  border: none;
}
</style>
